<template lang="pug">
div
  app-modal-cancelar-retificacao(
    @refresh='refresh'
    v-if="showModalRetificacao",
    :idProcesso='idProcesso',
    :numeroProcesso='numeroProcesso',
    :setor='setor'
    @closeModal="showModalRetificacao = false"
  )

  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :infoPrazos="infoPrazos",
    :pagina="filtro.pagina",
    :filtro="filtro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import { mapActions } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import AppModalCancelarRetificacao from '@/screens/analise/components/modal/AppModalCancelarRetificacao'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    ModalTrocarResponsavel,
    AppModalCancelarRetificacao
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('EM_ANALISE_OS'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      processosSelecionados: [],
      showModalResponsavel: false,
      processoTrocado: null,
      numeroProcesso: null,
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      idsProcessosAssinatura: [],
      showModalAssinatura: false,
      showModalRetificacao: false,
      showModalVisualizarProcesso: false,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.EM_ANALISE || [],
        filtroResponsavel: filtro?.filtroResponsavel?.EM_ANALISE_OS || [],
        filtroReceita: filtro?.filtroReceita?.EM_ANALISE_OS || [],
        filtroMunicipio: filtro?.filtroMunicipio?.EM_ANALISE_OS || [],
        filtroOrdemServico: filtro?.filtroOrdemServico?.EM_ANALISE_OS || [],
        filtroFuncao: filtro?.filtroFuncao?.EM_ANALISE_OS || [],
        filtroDataVencimento: filtro?.filtroDataVencimento?.EM_ANALISE_OS || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 6, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [] },
        { id: 7, titulo: 'Ordem de Serviço', propriedade: 'numeroOs', ordem: 5, acoes: [], exibir: () => !this.isEstadoBA() },
        { id: 8, titulo: 'Função', propriedade: 'funcoes', ordem: 5, acoes: [] },
        { id: 9, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => true },
        {
          id: 10, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: () => true },
            { id: 2, nome: 'Continuar Análise', icone: 'fa-file', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showContinuarAnaliseTecnico, showToltip: this.showToltipTecnicoCampo, textToltip: this.textToltipTecnicoCampo },
            { id: 3, nome: 'Revisar Análise', icone: 'fa-check', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showRevisarAnalise, showToltip: this.showToltipTecnicoCampo, textToltip: this.textToltipTecnicoCampo },
            { id: 4, nome: 'Cancelar Retificação', icone: 'fa-times', codigo: 'CANCELAR_RETIFICACAO', ordem: 4, show: this.showCancelarRetificacaoProcesssoTecnicoCampo },
            { id: 5, nome: 'Continuar Emissão de Certidão', icone: 'fa-file', codigo: 'CONTINUAR_EMISSAO_CERTIDAO_AREA', ordem: 1, show: this.showContinuarEmissaoCertidaoArea, showToltip: this.showToltipTecnicoCampo, textToltip: this.textToltipTecnicoCampo }

          ]
        }
      ]
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.ordemServicoClear()
  },

  watch: {
    async '$route' (to, from) {
      this.init()
      this.ordemServicoClear()
    }
  },
  methods: {
    ...mapActions({
      ordemServicoClear: 'ordemServico/clear'
    }),
    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario.perfilSelecionado.codigo) !== undefined
    },
    showRevisar (row) {
      return this.showRevisarAnalise && row.codigoStatus !== 'EM_REVISAO_VISTORIA'
    },
    CONTINUAR_ANALISE: (_this, { item }) => {
      _this.$router.push({
        name: 'analise/analisar-validar-sub',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ANALISE'
        }
      })
    },

    CONTINUAR_EMISSAO_CERTIDAO_AREA: (_this, { item }) => {
      _this.$router.push({
        name: 'CONTINUAR_EMISSAO_CERTIDAO_AREA',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'EM_EMISSAO_CERTIDAO_AREA'
        }
      })
    },

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.processoId
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },

    CANCELAR_RETIFICACAO (_this, {item}) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.protocolo = item.numeroProtocolo
      this.setor = item.setor
      this.showModalRetificacao = true
    },
    isEstadoBA () {
      return process.env.ESTADO === 'ba'
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaEmAnaliseOrdemServico.vue